module.exports = __webpack_public_path__ + "media/images/icon/x-twitter-dbcdac0b51f5e96382640f1b3a068618.svg";